import { render, staticRenderFns } from "./TransactionEditFormTransfer.vue?vue&type=template&id=66980bce&"
import script from "./TransactionEditFormTransfer.vue?vue&type=script&lang=js&"
export * from "./TransactionEditFormTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports